(() => {
  function initializeHeader(root = document) {
    const header = root.querySelector('.el-site-header');
    if (!header || header.elHeaderCleanup) return;

    const menuBtn = header.querySelector('.el-site-header__menu-nav');
    const overlay = header.querySelector('.el-site-header__overlay');
    const drawer = header.querySelector('.el-site-header__drawer');
    const closeBtn = header.querySelector('.el-site-header__menu-close');
    const section = header.closest('.shopify-section') || header.parentElement;
    const originalHeight = section.style.height;
    let headerHeight = header.offsetHeight;

    function openDrawer() {
      drawer.inert = false;
      drawer.classList.add('open');
      overlay.classList.add('show');
      menuBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('no-scroll');
      closeBtn.focus();
    }

    function closeDrawer() {
      if (!drawer) return;
      if (drawer.contains(document.activeElement)) menuBtn.focus();
      drawer.classList.remove('open');
      drawer.inert = true;
      overlay.classList.remove('show');
      menuBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('no-scroll');
    }

    function onKeyDown(event) {
      if (event.key === 'Escape') closeDrawer();
    }

    function updateSticky() {
      const sticky = window.scrollY > 30;
      section.style.height = sticky ? `${headerHeight}px` : originalHeight;
      header.classList.toggle('sticky', sticky);
    }

    function onResize() {
      header.classList.remove('sticky');
      section.style.height = originalHeight;
      headerHeight = header.offsetHeight;
      updateSticky();
    }

    if (menuBtn && overlay && drawer && closeBtn) {
      menuBtn.addEventListener('click', openDrawer);
      overlay.addEventListener('click', closeDrawer);
      closeBtn.addEventListener('click', closeDrawer);
      drawer.addEventListener('click', (event) => {
        if (event.target.closest('a')) closeDrawer();
      });
      header.addEventListener('keydown', onKeyDown);
    }

    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', onResize);
    updateSticky();

    header.elHeaderCleanup = () => {
      closeDrawer();
      window.removeEventListener('scroll', updateSticky);
      window.removeEventListener('resize', onResize);
      section.style.height = originalHeight;
    };
  }

  initializeHeader();
  document.addEventListener('shopify:section:load', (event) => initializeHeader(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelector('.el-site-header')?.elHeaderCleanup?.();
  });
})();
